exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iYtK5ZJJfqiDcw{color:#5e6c84;display:block;margin:35px auto;text-align:center;max-width:600px}.iYtK5ZJJfqiDcw h1{font-size:26px;margin-top:20px;margin-bottom:24px}.iYtK5ZJJfqiDcw p{font-size:18px;line-height:22px}", ""]);

// exports
exports.locals = {
	"errorMessage": "iYtK5ZJJfqiDcw"
};